<template>
  <div>
    <b-form-checkbox
      v-model="allSelected"
      aria-describedby="flavours"
      aria-controls="flavours"
      @change="selectAllItems"
    >
      {{ allSelected ? "Un-select All" : "Select All" }}
    </b-form-checkbox>
    <b-list-group class="doc-list-group">
      <b-list-group-item
        :key="key"
        v-for="(doc, key) in docs"
        href="#"
        class="flex-column align-items-start doc-list-item"
      >
        <div class="w-100">
          <b-container>
            <b-row>
              <b-col
                @click="selectItem(doc.data.documentId)"
                cols="1"
                align-self="center"
              >
                <b-form-checkbox
                  id="checkbox-1"
                  :checked="
                    selectedValues.find(
                      v => v.documentId == doc.data.documentId
                    ) != null
                  "
                  name="checkbox-1"
                  class="b-block"
                >
                </b-form-checkbox>
              </b-col>
              <b-col>
                <div class="d-flex flex-row justify-content-between">
                  <b-badge
                    @click="selectItem(doc.data.documentId)"
                    v-if="!hideStatusBadge"
                    :variant="statusVariant(doc.data.status)"
                    class="text-white mb-2"
                    >{{ statusText(doc.data.status) }}
                  </b-badge>
                  <custom-toggle
                    v-if="showToggle"
                    :value="
                      selectedValues.find(
                        v => v.documentId == doc.data.documentId
                      ) != null &&
                        !selectedValues.find(
                          v => v.documentId == doc.data.documentId
                        ).readonly
                    "
                    @toggle="toggleEditable(doc.data.documentId)"
                    :onlyRead="
                      doc.data.mode === 'File' ||
                        doc.data.status === 'Completed'
                    "
                    leftLabel="Read-only"
                    rightLabel="Editable"
                  />
                </div>
                <div @click="selectItem(doc.data.documentId)">
                  <span class="d-block" v-if="doc.data.fileName">
                    Ref #: {{ doc.data.documentRefNumber }} |
                    {{ doc.data.form.name }} |
                    <span
                      ><i class="fa fa-file-upload text-info ml-0"></i
                    ></span>
                    ({{ doc.data.fileName }})
                  </span>
                  <span v-else class="d-block">
                    Ref #: {{ doc.data.documentRefNumber }} |
                    {{ doc.data.form.name }}
                  </span>
                  <span v-if="!hideDateCreated" class="d-block">{{
                    formatDate(doc.data.createdAt)
                  }}</span>
                  <span
                    >{{ doc.data.patient.mrn }}-{{
                      doc.data.episodeOfCare.eocn
                    }}</span
                  >
                  <span>
                    {{ doc.data.patient.firstName }}
                    {{ doc.data.patient.middleName }}
                    {{ doc.data.patient.lastName }}</span
                  >
                  <div
                    v-if="
                      doc.data.totalSignatures &&
                        doc.data.totalSignatures -
                          doc.data.completedSignatures !=
                          0
                    "
                    class="d-block"
                    style="font-size: 0.775em; color: #d9534f"
                  >
                    {{
                      doc.data.totalSignatures - doc.data.completedSignatures
                    }}
                    <p
                      class="d-inline"
                      v-if="
                        doc.data.totalSignatures -
                          doc.data.completedSignatures !=
                          1
                      "
                    >
                      pending signatures
                    </p>
                    <p class="d-inline" v-else>
                      pending signature
                    </p>
                  </div>
                  <div
                    v-if="
                      doc.data.totalSignatures &&
                        doc.data.totalSignatures == doc.data.completedSignatures
                    "
                    style="font-size: 0.775em; color: #5cb85c"
                  >
                    All signed
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </b-list-group-item>
      <div class="text-center mt-3 mb-3" v-if="!hideLoadMore">
        <b-button
          v-if="!isLastPage && docs.length != 0"
          variant="light"
          @click="loadMore"
          >Load more...</b-button
        >
      </div>
    </b-list-group>
  </div>
</template>

<script>
import CustomToggle from "../controls/CustomToggle";

export default {
  name: "DocumentPicker",
  components: { CustomToggle },
  props: [
    "docs",
    "placeholder",
    "value",
    "multiple",
    "async",
    "isLastPage",
    "hideStatusBadge",
    "hideDateCreated",
    "hideLoadMore",
    "showToggle"
  ],
  data() {
    return {
      allSelected: false
    };
  },
  methods: {
    async clear() {
      this.allSelected = false;
    },
    selectItem(documentId) {
      let selectedValues = this.selectedValues;
      var documentIds = selectedValues.map(v => v.documentId);
      if (documentIds.indexOf(documentId) >= 0) {
        const index = documentIds.indexOf(documentId);
        selectedValues.splice(index, 1);
      } else {
        selectedValues.push({
          documentId: documentId,
          readonly: true
        });
      }
      this.selectedValues = selectedValues;
    },
    selectAllItems(checked) {
      let selectAll = checked
        ? this.docs.map(doc => ({
            documentId: doc.data.documentId,
            readonly: true
          }))
        : [];
      this.selectedValues = selectAll;
    },
    toggleEditable(documentId) {
      let selectedValues = this.selectedValues;
      var documentIds = selectedValues.map(v => v.documentId);
      if (documentIds.indexOf(documentId) >= 0) {
        const index = documentIds.indexOf(documentId);
        selectedValues[index].readonly = !selectedValues[index].readonly;
      }
      this.selectedValues = selectedValues;
    },
    loadMore(search, page) {
      this.$emit("loadMore", { search, page });
    },
    statusVariant(status) {
      switch (status) {
        case "Completed":
          return "success";
        case "Pending":
          return "warning";
        case "Active":
          return "success";
        case "Inactive":
          return "danger";
        case "Draft":
          return "danger";
        default:
          return "";
      }
    },
    statusText(status) {
      return status;
    }
  },
  computed: {
    selectedValues: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      }
    }
  }
};
</script>

<style scoped>
.doc-list-group {
  border-bottom: 0;
  margin-top: 10px;
  max-height: 400px;
  margin-bottom: 10px;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}
.doc-list-item {
  border-top: 0;
  border-left: 0;
  border-right: 0;
}
.pending-signatures {
  font-size: 12px;
}

.documents-info {
  font-size: 14px;
}
</style>
